var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rj-tabs',{model:{value:(_vm.tabsActive),callback:function ($$v) {_vm.tabsActive=$$v},expression:"tabsActive"}},[_c('rj-tab-pane',{attrs:{"name":"1","label":"待审批退换货合同"}},[_c('waitExchange')],1),_c('rj-tab-pane',{attrs:{"name":"2","label":"审批过的退换货合同"}},[_c('approveExchange')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }